import { IonLabel } from '@ionic/react';
import { useTranslation } from 'react-i18next';

import { Mission } from '@carers/views/Missions/models/Missions';
import { Request } from '@carers/views/Requests/models/Requests';
import Alert from '@shared/components/Alert/Alert';
import { CONTRACTS } from '@shared/constants/missionsConstants';

type ShortTermAlertProps = {
  mission: Request | Mission;
};

const ShortTermAlert = ({ mission }: ShortTermAlertProps) => {
  const { t } = useTranslation('app', {
    keyPrefix: 'carers.requests.detail.alerts.shortTermRequest',
  });

  const isShortTermMission = mission.contract.value === CONTRACTS.SHORT_TERM;

  if (!isShortTermMission) {
    return null;
  }

  return (
    <Alert type="warning" title={t('title')}>
      <IonLabel>{t('message')}</IonLabel>
    </Alert>
  );
};

export default ShortTermAlert;
